/* Shiny Leaf — site redesign JS (header, search, drawer, cards, collection filters) */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function initHeader(h) {
    if (!h || h.dataset.slInit) return; h.dataset.slInit = 1;
    var panels = $$('[data-sl-panel]', h), triggers = $$('[data-sl-open]', h), timer;
    function closeAll(except) {
      panels.forEach(function (p) { if (p !== except) p.classList.remove('is-open'); });
      triggers.forEach(function (t) { if (!except || t.dataset.slOpen !== except.dataset.slPanel) t.setAttribute('aria-expanded', 'false'); });
    }
    function open(name) {
      var p = $('[data-sl-panel="' + name + '"]', h); if (!p) return;
      closeAll(p); p.classList.add('is-open');
      triggers.forEach(function (t) { if (t.dataset.slOpen === name) t.setAttribute('aria-expanded', 'true'); });
      if (name === 'search') { var i = $('input[type=search]', p); if (i) setTimeout(function () { i.focus(); }, 30); }
    }
    triggers.forEach(function (t) {
      var name = t.dataset.slOpen;
      t.addEventListener('click', function (e) {
        e.preventDefault();
        var p = $('[data-sl-panel="' + name + '"]', h);
        if (p && p.classList.contains('is-open')) closeAll(); else open(name);
      });
      if (t.hasAttribute('data-sl-hover')) {
        t.addEventListener('mouseenter', function () { clearTimeout(timer); timer = setTimeout(function () { open(name); }, 90); });
        t.addEventListener('mouseleave', function () { clearTimeout(timer); });
      }
    });
    h.addEventListener('mouseleave', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { var s = $('[data-sl-panel="search"]', h); closeAll(s && s.classList.contains('is-open') ? s : null); }, 250);
    });
    h.addEventListener('mouseenter', function () { clearTimeout(timer); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(); closeDrawer(); } });
    document.addEventListener('click', function (e) { if (!h.contains(e.target)) closeAll(); });

    // drawer
    var drawer = $('[data-sl-drawer]');
    function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); document.documentElement.style.overflow = ''; } }
    $$('[data-sl-burger]', h).forEach(function (b) { b.addEventListener('click', function () { if (drawer) { drawer.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; } }); });
    if (drawer) {
      $$('[data-sl-close]', drawer).forEach(function (b) { b.addEventListener('click', closeDrawer); });
      $$('.sls-acc > button', drawer).forEach(function (b) {
        b.addEventListener('click', function () { var a = b.parentNode; a.classList.toggle('is-open'); b.setAttribute('aria-expanded', a.classList.contains('is-open')); });
      });
    }

    // predictive search
    var input = $('[data-sl-q]', h), res = $('[data-sl-res]', h), lab = $('[data-sl-reslab]', h), qt;
    if (input && res) {
      var initial = res.innerHTML, initialLab = lab ? lab.textContent : '';
      input.addEventListener('input', function () {
        clearTimeout(qt);
        var q = input.value.trim();
        if (q.length < 2) { res.innerHTML = initial; if (lab) lab.textContent = initialLab; return; }
        qt = setTimeout(function () {
          fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=hide')
            .then(function (r) { return r.json(); })
            .then(function (d) {
              var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
              if (lab) lab.textContent = ps.length ? 'Products' : 'No products found';
              res.innerHTML = ps.map(function (p) {
                var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
                return '<a href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" width="64" height="64" loading="lazy">' : '') +
                  '<span><strong>' + esc(p.title) + '</strong><span>' + esc(p.price ? (window.slMoney ? window.slMoney(p.price) : '$' + p.price) : '') + '</span></span></a>';
              }).join('');
            }).catch(function () {});
        }, 180);
      });
    }
  }

  function setCount(n) { $$('[data-sl-count]').forEach(function (c) { c.textContent = n; c.setAttribute('data-n', n); }); }


  /* after an item is added: refresh the cart count, then open the Qikify slide-in cart (with its upsells);
     if that app isn't there, go to the cart page */
  function afterAdd(btn, label) {
    function done() { if (btn) { btn.disabled = false; if (label != null) btn.textContent = label; } }
    function goCart() { window.location.href = window.slCartUrl || (root + 'cart'); }
    fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }).catch(function () {});
    if (typeof window.STICKY_CART_UPDATE === 'function' && typeof window.STICKY_CART_OPEN === 'function') {
      Promise.resolve().then(function () { return window.STICKY_CART_UPDATE(); })
        .then(function () { window.STICKY_CART_OPEN(); done(); })
        .catch(goCart);
    } else goCart();
  }
  window.slAfterAdd = afterAdd;

  // product cards: add to cart (one-time purchase — no selling plan)
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('form[data-sl-add]'); if (!f) return;
    e.preventDefault();
    var b = $('button', f), id = f.querySelector('[name=id]').value, txt = b.textContent;
    b.disabled = true; b.textContent = 'Adding…';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { afterAdd(b, txt); })
      .catch(function () { b.disabled = false; b.textContent = txt; f.submit(); });
  });

  // collection chips (client-side filter over the loaded grid)
  function initFilters(sec) {
    if (sec.dataset.slInit) return; sec.dataset.slInit = 1;
    var btns = $$('[data-sl-filter]', sec), cards = $$('[data-sl-cat]', sec), count = $('[data-sl-n]', sec);
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var f = b.dataset.slFilter, n = 0;
        btns.forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b); });
        cards.forEach(function (c) { var show = f === 'all' || (' ' + c.dataset.slCat + ' ').indexOf(' ' + f + ' ') > -1; c.hidden = !show; if (show) n++; });
        if (count) count.textContent = n + (n === 1 ? ' product' : ' products');
      });
    });
    var sort = $('[data-sl-sort]', sec);
    if (sort) sort.addEventListener('change', function () { var u = new URL(window.location.href); u.searchParams.set('sort_by', sort.value); window.location.href = u.toString(); });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('#cart-icon-bubble');
    if (!a) return;
    if (typeof window.STICKY_CART_OPEN === 'function') { e.preventDefault(); window.STICKY_CART_OPEN(); }
    else if (window.slCartUrl) { e.preventDefault(); window.location.href = window.slCartUrl; }
  });

  function init() {
    $$('[data-sl-header]').forEach(initHeader);
    $$('[data-sl-cgrid]').forEach(initFilters);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  window.slSetCartCount = setCount;
})();
/* inner pages: quiz + ingredient filter */
(function () {
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function initQuiz(root) {
    if (root.dataset.slInit) return; root.dataset.slInit = 1;
    var qs = $$('[data-sl-q]', root), results = $$('[data-sl-result]', root), ans = {}, cur = 0;
    function visible() {
      return qs.filter(function (q) {
        var c = q.getAttribute('data-show-if'); if (!c) return true;
        var p = c.split('='), vals = (p[1] || '').split(',');
        return vals.indexOf(ans[p[0]]) > -1;
      });
    }
    function show() {
      var v = visible();
      qs.forEach(function (q) { q.hidden = true; });
      results.forEach(function (r) { r.hidden = true; });
      if (cur < v.length) {
        var q = v[cur]; q.hidden = false;
        var n = q.querySelector('[data-sl-qn]'); if (n) n.textContent = 'Question ' + (cur + 1);
        var bar = q.querySelector('.sls-qz__bar i'); if (bar) bar.style.width = Math.round((cur + 1) / v.length * 100) + '%';
        var back = q.querySelector('[data-sl-back]'); if (back) back.hidden = cur === 0;
        var next = q.querySelector('[data-sl-next]'); if (next) next.disabled = !ans[q.dataset.slQ];
      } else {
        var key = ['q1', 'q2', 'q3'].map(function (k) { return ans[k] || '-'; });
        var hit = results.filter(function (r) {
          var p = r.getAttribute('data-sl-result').split('|');
          return p.every(function (x, i) { return x === '*' || x === key[i]; });
        })[0];
        if (hit) { hit.hidden = false; hit.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      }
    }
    qs.forEach(function (q) {
      $$('.sls-qz__o', q).forEach(function (o) {
        o.addEventListener('click', function () {
          $$('.sls-qz__o', q).forEach(function (x) { x.setAttribute('aria-pressed', x === o); });
          ans[q.dataset.slQ] = o.dataset.v;
          var next = q.querySelector('[data-sl-next]'); if (next) next.disabled = false;
        });
      });
      var nx = q.querySelector('[data-sl-next]'); if (nx) nx.addEventListener('click', function () { cur++; show(); });
      var bk = q.querySelector('[data-sl-back]'); if (bk) bk.addEventListener('click', function () { cur = Math.max(0, cur - 1); show(); });
    });
    $$('[data-sl-restart]', root).forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); ans = {}; cur = 0; $$('.sls-qz__o', root).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); }); show(); root.scrollIntoView({ behavior: 'smooth' }); }); });
    show();
  }
  function initIng(root) {
    if (root.dataset.slInit) return; root.dataset.slInit = 1;
    var cards = $$('.sls-ing', root), tab = 'all', letter = '';
    function apply() { cards.forEach(function (c) { var okT = tab === 'all' || c.dataset.w === tab || c.dataset.w === 'both'; var okL = !letter || c.dataset.l === letter; c.hidden = !(okT && okL); }); }
    $$('[data-sl-filter]', root).forEach(function (b) { b.addEventListener('click', function () { tab = b.dataset.slFilter; $$('[data-sl-filter]', root).forEach(function (x) { x.classList.toggle('is-on', x === b); }); apply(); }); });
    $$('[data-sl-letter]', root).forEach(function (b) { b.addEventListener('click', function () { letter = letter === b.dataset.slLetter ? '' : b.dataset.slLetter; $$('[data-sl-letter]', root).forEach(function (x) { x.classList.toggle('is-on', x.dataset.slLetter === letter); }); apply(); }); });
  }
  function init() { $$('[data-sl-quiz]').forEach(initQuiz); $$('[data-sl-ing]').forEach(initIng); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
/* Touch fix for chat widgets (Shopify Inbox etc.) */
(function () {
  document.documentElement.addEventListener('touchend', function (e) {
    var t = e.target;
    if (t && t.shadowRoot && t.tagName && t.tagName.indexOf('-') > -1) e.stopPropagation();
  });
})();
/* Shiny Leaf · instant feedback on Add to cart while the item is added and the slide cart loads */
(function () {
  var SEL = '[data-slp-add],[data-slp-sticky-add],form[data-sl-add] button', T;
  function all() { return document.querySelectorAll(SEL); }
  function set(cls) {
    all().forEach(function (b) {
      if (cls && !b.style.minWidth && b.offsetWidth) b.style.minWidth = b.offsetWidth + 'px';
      if (!cls) b.style.minWidth = '';
      b.classList.remove('is-adding', 'is-added'); if (cls) b.classList.add(cls);
    });
  }
  function start() { set('is-adding'); clearTimeout(T); T = setTimeout(function () { set(null); }, 10000); }
  function finish() { if (!document.querySelector('.is-adding')) return; set('is-added'); clearTimeout(T); T = setTimeout(function () { set(null); }, 1600); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-slp-add],[data-slp-sticky-add]');
    if (!b || b.disabled || b.classList.contains('is-adding')) return;
    start();
  }, true);
  document.addEventListener('submit', function (e) {
    if (e.target.closest && e.target.closest('form[data-sl-add]')) start();
  }, true);
  new MutationObserver(function () {
    if (document.body.classList.contains('qsc2-drawer-opened')) finish();
    var err = document.querySelector('[data-slp-error]:not([hidden])');
    if (err && document.querySelector('.is-adding')) { clearTimeout(T); set(null); }
  }).observe(document.body, { attributes: true, attributeFilter: ['class', 'hidden'], subtree: true });
})();

/* Shiny Leaf · slide-out cart (replaces the Qikify slide cart) */
(function () {
  if (window.__slCart) return; window.__slCart = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var onCartPage = /\/cart\/?$/.test(location.pathname);
  var TIERS = [{ n: 2, pct: 5 }, { n: 3, pct: 10 }];
  var PRO_SET = 'dht-pro-shampoo-conditioner', ORG_SET = 'dht-blocker-shampoo-conditioner',
      PEP_SET = 'anti-thinning-peptide-shampoo-and-conditioner-set-with-biotin-caffeine-saw-palmetto-2-x-16-oz',
      CAL = 'calcium-citrate-600mg-with-vitamin-d3-magnesium-fast-melting-cherry-flavored-120-tablets',
      MULTI = 'bariatric-multivitamin-with-iron-for-90-capsules';
  var PAIRS = {
    'dht-blocker-shampoo': ['dht-blocker-conditioner', PRO_SET],
    'dht-blocker-conditioner': ['dht-blocker-shampoo', PRO_SET],
    'dht-blocker-shampoo-conditioner': [PRO_SET, PEP_SET],
    'dht-pro-shampoo': ['dht-pro-conditioner', ORG_SET],
    'dht-pro-conditioner': ['dht-pro-shampoo', ORG_SET],
    'dht-pro-shampoo-conditioner': [ORG_SET, PEP_SET],
    'anti-thinning-peptide-shampoo-anti-hair-loss-thickening-hydrating-shiny-leaf': ['anti-thinning-peptide-conditioner-anti-hair-loss-hydrating-thickening-16oz', PRO_SET],
    'anti-thinning-peptide-conditioner-anti-hair-loss-hydrating-thickening-16oz': ['anti-thinning-peptide-shampoo-anti-hair-loss-thickening-hydrating-shiny-leaf', PRO_SET],
    'bariatric-multivitamin-with-iron-for-90-capsules': [CAL, PRO_SET],
    'bariatric-multivitamin-iron-free': [CAL, PRO_SET],
    'free-bariatric-multivitamin-with-iron-blister-pack': [MULTI, CAL]
  };
  PAIRS[PEP_SET] = [PRO_SET, ORG_SET];
  PAIRS[CAL] = [MULTI, PRO_SET];
  var FALLBACK = [PRO_SET, ORG_SET];

  var cart = null, busy = false, lastFocus = null, prodCache = {};
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function img(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function decode(s) { var t = document.createElement('textarea'); t.innerHTML = s; return t.value; }

  /* ---------- markup ---------- */
  var el = document.createElement('div');
  el.className = 'slc';
  el.innerHTML =
    '<div class="slc-scrim" data-slc-close></div>' +
    '<aside class="slc-panel" role="dialog" aria-modal="true" aria-labelledby="slc-title" tabindex="-1">' +
      '<header class="slc-head"><h2 id="slc-title">Your cart <span class="slc-badge" data-slc-n>0</span></h2>' +
      '<button type="button" class="slc-x" data-slc-close aria-label="Close cart"><svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button></header>' +
      '<div class="slc-bar">Free US shipping on every order</div>' +
      '<div class="slc-tier" data-slc-tier hidden></div>' +
      '<div class="slc-body" data-slc-body></div>' +
      '<footer class="slc-foot" data-slc-foot hidden>' +
        '<div class="slc-sum"><span>Subtotal</span><span class="slc-total" data-slc-total></span></div>' +
        '<p class="slc-save" data-slc-save hidden></p>' +
        '<p class="slc-note">Free US shipping. Taxes calculated at checkout.</p>' +
        '<a class="slc-go" href="' + root + 'checkout" data-slc-checkout>Checkout</a>' +
        '<p class="slc-trust"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 018 0v3"/></svg>Secure checkout · 30-day money-back guarantee</p>' +
      '</footer>' +
      '<div class="slc-live" aria-live="polite" data-slc-live></div>' +
    '</aside>';
  function mount() { if (!el.isConnected) document.body.appendChild(el); }
  if (document.body) mount(); else document.addEventListener('DOMContentLoaded', mount);
  var panel = el.querySelector('.slc-panel'), body = el.querySelector('[data-slc-body]'), foot = el.querySelector('[data-slc-foot]'),
      tier = el.querySelector('[data-slc-tier]'), live = el.querySelector('[data-slc-live]');

  /* ---------- open / close ---------- */
  function open() {
    mount();
    if (el.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    document.documentElement.classList.add('slc-lock');
    document.body.classList.add('sl-cart-open', 'qsc2-drawer-opened');
    setTimeout(function () { panel.focus({ preventScroll: true }); }, 30);
  }
  function close() {
    if (!el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    document.documentElement.classList.remove('slc-lock');
    document.body.classList.remove('sl-cart-open', 'qsc2-drawer-opened');
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }
  el.addEventListener('click', function (e) { if (e.target.closest('[data-slc-close]')) close(); });
  document.addEventListener('keydown', function (e) {
    if (!el.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = panel.querySelectorAll('a[href],button:not([disabled]),input');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- data ---------- */
  function getCart() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); }); }
  function product(h) {
    if (!prodCache[h]) prodCache[h] = fetch(root + 'products/' + h + '.js').then(function (r) { if (!r.ok) throw r; return r.json(); }).catch(function () { return null; });
    return prodCache[h];
  }
  function setCount(n) {
    document.querySelectorAll('[data-sl-count]').forEach(function (c) { c.textContent = n; c.setAttribute('data-n', n); });
    var a = document.getElementById('cart-icon-bubble'); if (a) a.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
    el.querySelector('[data-slc-n]').textContent = n;
  }
  function refresh() { return getCart().then(function (c) { cart = c; render(); return c; }); }

  /* ---------- render ---------- */
  function tierInfo(c) {
    var q = 0;
    c.items.forEach(function (i) { if (!i.selling_plan_allocation && i.final_price > 0 && !i.gift_card) q += i.quantity; });
    var next = null, cur = null;
    TIERS.forEach(function (t) { if (q >= t.n) cur = t; else if (!next) next = t; });
    return { q: q, cur: cur, next: next };
  }
  function renderTier(c) {
    if (!c.item_count) { tier.hidden = true; return; }
    var t = tierInfo(c), max = TIERS[TIERS.length - 1].n, pct = Math.min(100, Math.round(t.q / max * 100)), msg;
    if (t.next) {
      var need = t.next.n - t.q;
      msg = t.q === 0 ? 'Add one-time items to unlock multi-buy savings'
        : 'Add <b>' + need + ' more item' + (need > 1 ? 's' : '') + '</b> to save <b>' + t.next.pct + '%</b>' + (t.cur ? ' (you’re saving ' + t.cur.pct + '% now)' : '');
    } else msg = 'You’re saving <b>' + t.cur.pct + '%</b>, our best multi-buy price';
    var marks = TIERS.map(function (x) { return '<span class="slc-mark' + (t.q >= x.n ? ' on' : '') + '" style="left:' + (x.n / max * 100) + '%">' + x.pct + '%</span>'; }).join('');
    tier.innerHTML = '<p>' + msg + '</p><div class="slc-track" aria-hidden="true"><i style="width:' + pct + '%"></i>' + marks + '</div>';
    tier.hidden = false;
  }
  function lineHTML(i) {
    var plan = i.selling_plan_allocation && i.selling_plan_allocation.selling_plan ? i.selling_plan_allocation.selling_plan.name : '';
    var variant = i.product_has_only_default_variant ? '' : (i.variant_title || '');
    var meta = [variant, plan].filter(Boolean).map(esc).join(' · ');
    var price = i.final_line_price === 0 ? '<b>Free</b>' :
      (i.original_line_price > i.final_line_price ? '<s>' + money(i.original_line_price) + '</s>' : '') + '<b>' + money(i.final_line_price) + '</b>';
    var disc = (i.line_level_discount_allocations || []).map(function (d) { return '<span class="slc-tag">' + esc(d.discount_application.title) + '</span>'; }).join('');
    return '<li class="slc-line" data-key="' + esc(i.key) + '">' +
      '<a class="slc-img" href="' + esc(i.url) + '" tabindex="-1">' + (i.image ? '<img src="' + esc(img(i.image, 180)) + '" alt="" width="84" height="84" loading="lazy">' : '') + '</a>' +
      '<div class="slc-info">' +
        '<div class="slc-top"><a class="slc-name" href="' + esc(i.url) + '">' + esc(decode(i.product_title)) + '</a>' +
        '<button type="button" class="slc-rm" data-slc-qty="0" aria-label="Remove ' + esc(decode(i.product_title)) + '"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 12a2 2 0 002 2h6a2 2 0 002-2l1-12M9 7V4h6v3"/></svg></button></div>' +
        (meta ? '<p class="slc-meta">' + meta + '</p>' : '') + disc +
        '<div class="slc-row"><div class="slc-qty" role="group" aria-label="Quantity">' +
          '<button type="button" data-slc-qty="' + (i.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
          '<span aria-live="polite">' + i.quantity + '</span>' +
          '<button type="button" data-slc-qty="' + (i.quantity + 1) + '" aria-label="Increase quantity">+</button></div>' +
        '<div class="slc-price">' + price + '</div></div>' +
      '</div></li>';
  }
  function render() {
    if (!cart) return;
    setCount(cart.item_count);
    renderTier(cart);
    if (!cart.item_count) {
      body.innerHTML = '<div class="slc-empty"><p class="slc-empty-h">Your cart is empty</p><p>Find your routine.</p>' +
        '<div class="slc-empty-links"><a href="' + root + 'collections/hair-care-products">Shop hair care</a><a href="' + root + 'collections/bariatric-multivitamin">Shop bariatric vitamins</a></div></div>' +
        '<div data-slc-recs></div>';
      foot.hidden = true;
    } else {
      body.innerHTML = '<ul class="slc-lines">' + cart.items.map(lineHTML).join('') + '</ul><div data-slc-recs></div>';
      foot.hidden = false;
      el.querySelector('[data-slc-total]').innerHTML = (cart.original_total_price > cart.total_price ? '<s>' + money(cart.original_total_price) + '</s> ' : '') + money(cart.total_price);
      var save = el.querySelector('[data-slc-save]');
      if (cart.total_discount > 0) { save.textContent = 'You’re saving ' + money(cart.total_discount) + ' on this order'; save.hidden = false; } else save.hidden = true;
    }
    renderRecs();
  }
  var recToken = 0;
  function renderRecs() {
    var box = body.querySelector('[data-slc-recs]'); if (!box) return;
    var inCart = {}; cart.items.forEach(function (i) { inCart[i.handle] = 1; });
    var want = [];
    cart.items.slice().forEach(function (i) { (PAIRS[i.handle] || []).forEach(function (h) { want.push(h); }); });
    if (cart.items.some(function (i) { return !PAIRS[i.handle]; })) {
      cart.items.forEach(function (i) { var t = (i.product_title || '').toLowerCase(); if (!PAIRS[i.handle]) { if (/multivitamin|calcium/.test(t) && !/shampoo|conditioner/.test(t)) want.push(PRO_SET); else if (/multivitamin/.test(t)) want.push(CAL); } });
    }
    FALLBACK.forEach(function (h) { want.push(h); });
    var seen = {}, list = want.filter(function (h) { if (inCart[h] || seen[h]) return false; seen[h] = 1; return true; }).slice(0, 4);
    var tok = ++recToken;
    Promise.all(list.map(product)).then(function (ps) {
      if (tok !== recToken) return;
      var picks = ps.filter(function (p) { return p && p.available; }).slice(0, 2);
      if (!picks.length) { box.innerHTML = ''; return; }
      box.innerHTML = '<section class="slc-recs"><h3>Complete your routine</h3>' + picks.map(function (p) {
        var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
        var pic = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
        return '<div class="slc-rec"><img src="' + esc(img(pic, 140)) + '" alt="" width="60" height="60" loading="lazy">' +
          '<div class="slc-rec-t"><a href="' + root + 'products/' + esc(p.handle) + '">' + esc(decode(p.title)) + '</a><span>' + money(v.price) + '</span></div>' +
          '<button type="button" class="slc-add" data-slc-add="' + v.id + '">+ Add</button></div>';
      }).join('') + '</section>';
    });
  }

  /* ---------- actions ---------- */
  function setBusy(on) { busy = on; panel.classList.toggle('is-busy', on); }
  function change(key, q) {
    if (busy) return; setBusy(true);
    fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, q) }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function (c) { cart = c; render(); live.textContent = q <= 0 ? 'Item removed' : 'Quantity updated'; })
      .catch(function (e) { live.textContent = (e && e.description) || 'Couldn’t update the cart. Please try again.'; refresh(); })
      .then(function () { setBusy(false); });
  }
  function addVariant(id, btn) {
    if (busy) return; setBusy(true);
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; return refresh(); })
      .then(function () { live.textContent = 'Added to cart'; })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = '+ Add'; } live.textContent = 'Couldn’t add that item. Please try again.'; })
      .then(function () { setBusy(false); });
  }
  el.addEventListener('click', function (e) {
    var q = e.target.closest('[data-slc-qty]');
    if (q) { var line = q.closest('[data-key]'); if (line) change(line.getAttribute('data-key'), +q.getAttribute('data-slc-qty')); return; }
    var a = e.target.closest('[data-slc-add]');
    if (a) addVariant(a.getAttribute('data-slc-add'), a);
  });

  /* ---------- public: open after any add ---------- */
  function afterAdd(btn, label) {
    if (onCartPage) { location.reload(); return; }
    open();
    panel.classList.add('is-loading');
    return refresh().then(function () {
      if (btn) { btn.disabled = false; if (label != null) btn.textContent = label; }
    }).catch(function () { location.href = root + 'cart'; })
      .then(function () { panel.classList.remove('is-loading'); });
  }
  window.slAfterAdd = afterAdd;
  try { Object.defineProperty(window, 'slAfterAdd', { configurable: true, get: function () { return afterAdd; }, set: function () {} }); } catch (e) {} window.slCart = { open: function () { open(); refresh(); }, close: close, refresh: refresh };

  /* product-card "Add to cart" forms: add here and open this cart */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('form[data-sl-add]'); if (!f) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var b = f.querySelector('button'), id = f.querySelector('[name=id]').value, txt = b ? b.textContent : null;
    if (b) { b.disabled = true; b.textContent = 'Adding…'; }
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; return afterAdd(b, txt); })
      .catch(function () { if (b) { b.disabled = false; b.textContent = txt; } f.submit(); });
  }, true);

  /* header cart icon opens the slide cart (except on the cart page) */
  document.addEventListener('click', function (e) {
    if (onCartPage || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var a = e.target.closest && e.target.closest('a[href="' + root + 'cart"], a[href="/cart"], #cart-icon-bubble');
    if (!a || el.contains(a)) return;
    e.preventDefault(); e.stopImmediatePropagation();
    window.slCart.open();
  }, true);

  /* keep the count right on load and when the page is restored from the back button */
  function sync() { getCart().then(function (c) { cart = c; setCount(c.item_count); if (el.classList.contains('is-open')) render(); }).catch(function () {}); }
  window.addEventListener('pageshow', function (e) { if (e.persisted) sync(); });
  sync();
})();
